import React from 'react';

var stringsByLanguage = {};
var currentLanguage = 'en';
var observers = [];

// TODO: read files from disk or window.CACHE
// Right now, put all language keys here

stringsByLanguage = {
  en: {
    notavailable: 'N/A',
    consent: {
      accept: 'Accept',
      noThanks: 'No thanks!',
    },
    header: {
      home: 'Home',
      discover: 'Discover',
      plus: 'Acast+',
      podcasters: 'Podcasters',
      advertisers: 'Advertisers',
      about: 'About',
      press: 'Press',
      news: 'News',
    },
    footer: {
      connect: 'Connect with Acast',
      about: 'About Acast',
      contact: 'Contact us',
      jobs: 'We are hiring',
      press: 'Press',
      faq: 'FAQ',
      serviceStatus: 'Services status',
      terms: 'Terms & Conditions',
      privacy: 'Privacy Policy',
      cookies: 'Cookie Policy',
      newsletter: {
        title: 'Subscribe to our newsletter',
        subtitle: 'Stay up-to-date on new releases, Acast features and more.',
        email: 'Your Email',
        status: {
          error: 'Oops, something went wrong!',
          ok: 'Thank you!',
          invalid: 'Invalid e-mail address. Please try again.',
        },
      },
      social: {
        linkedin: {
          title: 'Follow us on LinkedIn',
          link: 'https://www.linkedin.com/company/acast-ab',
        },
        twitter: {
          title: 'Follow us on Twitter',
          link: 'https://twitter.com/acast',
        },
        facebook: {
          title: 'Like us on Facebook',
          link: 'https://www.facebook.com/acaststories',
        },
      },
    },
    common: {
      by: 'By',
      shows: 'Shows',
      loadMore: 'Load More',
      episodes: 'Episodes',
      moreEpisodes: 'More episodes',
      noResults: 'No results.',
      searchPlaceholder: 'Search Podcast',
      errors: {
        search: 'Sorry, there was a problem loading the search results.',
      },
    },
    home: {
      hero: {
        title: 'The Future of Podcasts',
        body:
          'Your favorite shows. New voices. Stories you’ll love. Follow, share and connect with podcasters around the world.',
        getApp: 'Get the App',
        listen: 'Start Listening',
      },
      staffPicks: {
        title: 'Staff Picks',
        discover: 'Discover more shows',
      },
      learnMore: {
        title: 'An Enriched Experience',
        body:
          'Acast works with podcasters to bring your favorite shows to life with additional, dynamic content that’s always entertaining.',
        dive: 'Dive a little deeper into the stories you love.',
        extra: 'Extra images, videos, and links enrich each narrative.',
        learnMore: 'Learn More',
      },
      getApp: {
        title: 'Get the Acast App',
        body:
          'Now available for Android, iOS, and Windows, the Acast app means that discovering your new favorite podcasts has never been easier.',
      },
    },
    discover: {
      staffPicks: {
        title: 'Staff Picks',
        body: 'Handpicked by the team at Acast',
        more: 'Load More',
      },
      trending: {
        title: 'Trending',
        subtitle: 'Most popular podcasts right now',
        acasts: 'Top 10 episodes',
      },
      categories: {
        title: 'Categories',
        body:
          'Looking for a laugh? Feeling blue? Find a podcast to match your interests or current mood',
        options: [
          { value: 'comedy', name: 'Comedy' },
          { value: 'business', name: 'Business' },
          { value: 'education', name: 'Education' },
          { value: 'gamesandhobbies', name: 'Games & Hobbies' },
          { value: 'kidsandfamilies', name: 'Kids & Families' },
          { value: 'music', name: 'Music' },
          { value: 'newsandpolitics', name: 'News & Politics' },
          { value: 'scienceandmedicine', name: 'Science & Medicine' },
          { value: 'sportsandrecreation', name: 'Sports & Recreation' },
          { value: 'societyandculture', name: 'Society & Culture' },
          { value: 'technology', name: 'Technology' },
          { value: 'tvandfilm', name: 'TV & Film' },
        ],
      },
      curated: {
        sports: {
          title: 'Sports',
          subtitle:
            'The NFL and EUFA are kicking off! Hear the latest bulletins, gossip, scores, and sports news',
          body: '',
        },
        roadtrip: {
          title: 'Road Trip',
          subtitle:
            'Ready to hit the highway? Press play on these amazing stories',
          body: '',
        },
      },
    },
    podcasters: {
      hero: {
        title: 'Join the world’s top podcasters and start making money.',
        tierOffers: [
          {
            title: 'Non-hosted Show',
            intent: 'podcasters-none-hosted',
            preamble:
              'Provide us with your RSS feed to allow listeners to discover your show on the Acast apps and website.',
            bullets: [
              'Discoverable on the Acast App',
              'Available on iOS, Android and Windows phones',
              'Listen to your show on www.acast.com',
            ],
            successMessage: {
              body:
                'Thanks! Your show will be added to our catalogue in the next few hours. Once updated in the system, find your show via the link below.',
              footnote:
                'Please note certain browsers may cache an empty webpage, and take some time to clear.',
            },
            formFields: [
              {
                name: 'podcastRss',
                type: 'url',
                label: 'RSS feed of podcast',
                placeholder: 'http://...',
                externalValidation: {
                  endpoint: '/api/validate-rss-url?rssUrl=',
                  pending: 'Validating feed...',
                  invalid: 'Invalid RSS feed.',
                  valid: 'Valid RSS feed.',
                  duplicated: 'This RSS feed is already available on Acast.',
                },
              },
              {
                name: 'showUrl',
                type: 'text',
                pattern: '^[a-z0-9]+(?:-[a-z0-9]+)*$',
                title: 'Can only contain letters, numbers and dashes.',
                label: 'Show URL',
                prefix: 'acast.com/',
                externalValidation: {
                  endpoint: '/api/validate-show-url?showUrl=',
                  pending: 'Checking show URL availability...',
                  invalid: 'Show URL is already taken.',
                  valid: 'Show URL is available.',
                },
              },
            ],
          },
          {
            title: 'Hosted Show',
            intent: 'podcasters-hosted',
            preamble:
              'Join us for real. Gain full access to our tools and start generating revenue through advertisements and sponsorships.\n',
            bullets: [
              'Safe migration from your existing platform',
              'Access to the Create publishing tool',
              'Industry leading stats to track growth',
              'Dedicated international sales teams',
              'Dynamic audio insertion to monetise your back catalogue',
            ],
            successMessage: {
              body:
                'Many thanks for your hosting request. We will be in touch shortly!',
            },
            formFields: [
              {
                name: 'name',
                type: 'text',
                label: 'Your name',
              },
              {
                name: 'email',
                type: 'email',
                label: 'Your email',
              },
              {
                name: 'location',
                type: 'text',
                label: 'Location',
              },
              {
                name: 'podcastName',
                type: 'text',
                label: 'Name of podcast',
              },
              {
                name: 'podcastRss',
                type: 'url',
                label: 'RSS feed of podcast',
                placeholder: 'http://...',
              },
              {
                name: 'podcastListeners',
                type: 'select',
                label: 'Approx. number of listeners/week',
                options: [
                  { value: '0 - 5,000' },
                  { value: '5,000 - 10,000' },
                  { value: '10,000 - 20,000' },
                  { value: 'More than 20,000' },
                ],
              },
            ],
          },
          {
            title: 'New Show',
            intent: 'podcasters-hosted-new',
            preamble:
              'Have a great idea for a show? Think it could be the next big thing? Get in touch now to see if Acast is the place for you.',
            bullets: [
              'Launch with a brand new feed',
              'Access to the Create publishing tool',
              'Industry leading stats to track growth',
              'Dedicated international sales teams',
              'Dynamic audio insertion to monetise your back catalogue',
            ],
            successMessage: {
              body:
                'Many thanks for your hosting request. We will be in touch shortly!',
            },
            formFields: [
              {
                name: 'name',
                type: 'text',
                label: 'Your name',
              },
              {
                name: 'email',
                type: 'email',
                label: 'Your email',
              },
              {
                name: 'location',
                type: 'text',
                label: 'Location',
              },
              {
                name: 'social',
                type: 'text',
                label: 'Social media reach',
              },
              {
                name: 'company',
                type: 'text',
                label: 'Company name',
              },
              {
                name: 'comment',
                type: 'textarea',
                label: 'Message',
              },
            ],
          },
        ],
        getStarted: 'Get Started',
      },
      acastplus: {
        title: 'Acast+ is the marketplace for podcasts.',
        body:
          'We created a destination where you can sell your premium content directly to your loyal audience for a price you set yourself.',
        button: 'Contact us',
      },
      spreadStory: {
        title: 'Go Far and Wide',
        preamble:
          'Your podcasts are available on our iOS & Android apps, our embeddable widget, our website, and through any other podcast listening client.',
      },
      monthlyRevenue: {
        title: 'Our Revenue Model',
        body:
          'Acast is free. Focus on creating great content, and let us focus on making you money. You decide where ads are placed and how you sell your premium content, and we split the revenue. As your audience grows, so will your earnings.',
      },
      acastCreate: {
        title: 'Acast Create',
        body:
          'Forget technical mumbo-jumbo. Our user-friendly, intuitive Create tool simplifies the podcast upload and creation process.',
      },
      statistics: {
        title: 'See the Numbers',
        body:
          'We make it easy to understand your audience. Our statistics let you see where your fans live, what they like, what they share, and how they interact with your podcasts.',
      },
      interactiveMedia: {
        title: 'Interactive Media',
        body:
          'Enrich your story with extra media content – videos, images, external links and more – that engages your audience and offers them a deeper understanding of your story. The more value for listeners, the more for you.',
      },
      app: {
        title: 'App',
        body:
          'Give your audience the richest experience—and increase your revenue—by promoting listening via our app.',
      },
      embed: {
        title: 'Widget',
        body:
          'Easily embedded onto any website or blog, our interactive widget works across both desktop and mobile.',
      },
      rss: {
        title: 'RSS',
        body:
          'Enable your listeners to tune in on other podcasting clients such as iTunes or Stitcher.',
      },
      form: {
        title: 'Add your podcast to Acast',
        selectPlan: {
          title: 'What do you prefer:',
          options: [
            {
              value: 'podcasters-none-hosted',
              name: 'I want to join Acast as a non-hosted podcast',
              preSelected: true,
            },
            {
              value: 'podcasters-hosted',
              name: 'I want to join Acast as a hosted podcast',
            },
            {
              value: 'podcasters-hosted-new',
              name:
                'I want to join Acast as a hosted podcast with a brand new show',
            },
          ],
        },
        fields: {
          name: {
            text: '* Your name:',
            required: 'true',
          },
          email: {
            text: '* Your e-mail:',
            required: 'true',
          },
          podcastName: {
            text: '* Name of podcast:',
            required: 'true',
          },
          podcastRss: {
            text: '* RSS feed of podcast:',
            required: 'true',
          },
          location: {
            text: '* Location:',
            required: 'true',
          },
          podcastListeners: {
            text: '* Approx. number of listeners/week:',
            required: 'true',
            data: [
              { name: '0 - 5000' },
              { name: '5001 - 10000' },
              { name: '10001 - 20000+' },
            ],
          },
          company: {
            text: 'Company name:',
            required: 'false',
          },
          SocialMediaReach: {
            text: '* Social media reach:',
            required: 'true',
          },
          comments: {
            text: '* Message:',
            required: 'true',
          },
        },
        send: 'Send',
        status: {
          okHosting: "Thank you, we'll be in touch shortly.",
          okImport: "Thanks for your suggestion. We'll check it out!",
          error: 'Something went wrong, try again later.',
          formError: 'Please fill in the form.',
          invalidEmailAddress: 'Invalid e-mail address.',
        },
      },
    },
    advertisers: {
      whyacast: {
        title: 'Why Acast?',
        body:
          'When you advertise with Acast you reach 18 million unique individuals across our 45 million monthly listenings. You reach them in the context of the Financial Times podcast or the Economist podcasts, or Vogue podcasts. Or any of our other premium podcasts. The people you reach will be interested in the content and they will listen through headphones. Welcome to Acast!',
      },
      hero: {
        title: 'Podcast advertising is more effective',
        source: {
          title: 'Source',
          url:
            'http://www.edisonresearch.com/wp-content/uploads/2016/05/The-Podcast-Consumer-2016.pdf',
        },
        bullets: [
          {
            body:
              'Listeners spend more time with podcasts than any other audio, consuming an average of five episodes per week.',
            className: 'passion-bullet',
          },
          {
            body:
              'With 90% of listeners consuming podcasts up close and in-ear, an intimate bond is formed between the host and listener.',
            className: 'personal-bullet',
          },
          {
            body:
              'Listeners hit download and listen immediately for seamless consumption. A majority of the listening occurs at home away from distraction.',
            className: 'undivided-bullet',
          },
          {
            body:
              'Podcast listeners are more likely to have a college or higher education along with a $100k+ househould income.',
            className: 'education-bullet',
          },
        ],
      },
      beyond: {
        category: 'PRODUCTS',
        title: 'Go beyond the host-read ads with branded segments',
        body:
          'Acast Branded Segments are high touch, 3-5 minute audio stories in the mid-roll/post-roll position. These extended spots can include interviews with customers or company representatives and more.',
      },
      sponsor: {
        category: 'PRODUCTS',
        title: 'Sponsored bonus episodes',
        body:
          'A podcast host in our network will create a full episode in their unique voice on behalf of a brand. You’ll gain access to a podcast’s devoted audience and receive 100% SOV. ',
      },
      why: {
        title: 'Why podcasts?',
        paragraphs: [
          'Podcasts and audio on demand are exploding globally. Podcast listeners actively choose their own content—and normally listen using headphones—making them an extremely captive audience. There’s no better kind.',
          'Plus, our unique technology lets you target the right audience at the right time using dynamic audio, video, or display banners to promote your brand.',
        ],
      },
      stats: {
        title: 'Formats and opportunities',
        facts: [
          {
            title: 'Audio',
            body:
              'Go back to basics with an audio spot, the starting point for any Acast campaign. These can be effective when video and display banners cannot be displayed.',
          },
          {
            title: 'Video & Display',
            body:
              'Our unique technology means you can show dynamic videos and display banners to promote your brand.',
          },
          {
            title: 'Sponsorships',
            body:
              'We seamlessly integrate sponsored content, providing the same metrics you’d expect from a traditional publishing platform.',
          },
        ],
      },
      dynamicad: {
        title: 'Dynamic-ad insertion',
        body:
          'With dynamic-ad insertion, we can share your message across our full network of shows, a content channel, or a customized brand story in a select show.',
        examples: 'EXAMPLE OF CREATIVES',
      },
      opportunities: {
        title: 'Formats and Opportunities',
        types: {
          audio: {
            title: 'Audio',
            body:
              'Go back to basics with an audio spot, the starting point for any Acast campaign. These are effective when video and display banners cannot be displayed.',
          },
          video: {
            title: 'Video and Display',
            body:
              'Our unique technology means you can show dynamic videos and display banners to promote your brand.',
          },
          sponsorship: {
            title: 'Sponsorships',
            body:
              'We seamlessly integrate sponsored content, providing the same metrics you’d expect from a traditional publishing platform.',
          },
        },
        dynamic: [
          'Dynamic Audio',
          'Dynamic Sponsorship',
          'Dynamic Video',
          'Dynamic Display',
        ],
        medias: {
          app: 'App',
          widget: 'Widget',
          rss: 'RSS (External)',
        },
      },
      start: {
        title: 'Are you ready?',
        body: 'Contact our sales team today.',
        regions: {
          sweden: {
            title: 'Sales Sweden',
            companyName: 'Acast AB',
            visitingAddress: 'Drottninggatan 82',
            email: 'sales.swe@acast.com',
          },
          uk: {
            title: 'Sales UK',
            companyName: 'Acast Stories Ltd',
            visitingAddress:
              'The Gridiron Building, One Pancras Square, London',
            email: 'sales.uk@acast.com',
          },
          us: {
            title: 'Sales US',
            companyName: 'Acast Stories Inc',
            visitingAddress: '95 Grand St Apt 3, 2 Floor, NY',
            email: 'sales.us@acast.com',
          },
          norway: {
            title: 'Sales Norway',
            email: 'sales.norway@acast.com',
          },
        },
      },
    },
    about: {
      hero: {
        title: 'About Us',
        paragraphs: [
          'Acast is a curated platform for podcasts. We connect listeners, podcast creators, and advertisers in a fully integrated, one-stop shop.',
          'Podcast discovery, listening, hosting, and RSS distribution: we’re the first to do it all.',
        ],
      },
      listeners: {
        title:
          'Listeners need an easier way of discovering new podcasts—and they want a richer experience, too.',
        button: 'Start Listening',
        paragraphs: [
          'Acast’s patent-pending technology enables them to interact with podcast creators in new, exciting ways, following and sharing moments from their favorite shows.',
          'We also help listeners discover new content. We suggest new voices and popular shows, as well as fully curated lists.',
          'Acast podcasts also include extra videos, images, audio clips, and external links that enrich the experience. Acast makes good stories great.',
        ],
      },
      podcasters: {
        title:
          'Podcasters need a simple publishing service with the tools to help create better shows.',
        button: 'Add Your Show',
        buttonReadMore: 'Read More',
        paragraphs: [
          'Acast’s publishing platform enables creators to support each podcast with rich content, making their stories more engaging and, in turn, driving revenue.',
          'This is the core of our approach: providing above-and-beyond opportunities for each episode published on Acast.',
          'We make it easy for podcasters to share their shows where the listening happens: on iTunes, podcast clients, and social media.  They can even monetize content from their back catalog – we think that’s great.',
        ],
      },
      advertisers: {
        title: 'Advertisers need accurate, timely data.',
        button: 'Learn More',
        paragraphs: [
          'Acast offers true metrics for groundbreaking ad formats, such as fully integrated, dynamic ads during a podcast. In fact, we were the first platform in the world to do it.',
          'We were also the first to introduce programmatic ad buys within podcasts.',
          'Looking to partner with the world leader in podcast advertising? Look no further.',
        ],
      },
      where: {
        title: 'Find Us',
        sweden: {
          title: 'Stockholm (HQ)',
          street: 'Kungsgatan 12',
          city: 'Stockholm 111 35',
          country: 'Sweden',
        },
        uk: {
          title: 'London',
          street: '3 Green Mews, Bevenden Street',
          city: 'London',
          country: 'United Kingdom',
        },
        us: {
          title: 'New York',
          street: '95 Grand St, Apt 3, 2nd Floor',
          city: 'New York, NY 10013',
          country: 'USA',
        },
        losangeles: {
          title: 'Los Angeles',
          street: '12655 W Jefferson Blvd. Floor 6 Suite 122',
          city: 'Los Angeles, CA 90066',
          country: 'USA',
        },
      },
      contact: {
        title: 'Get In Touch',
        general: {
          title: 'General',
          contacts: [{ email: 'hello@acast.com' }],
        },
        support: {
          title: 'Support',
          contacts: [{ email: 'support@acast.com' }],
        },
        media: {
          title: 'Press Inquiries',
          contacts: [
            { email: 'press@acast.com' },
            { email: 'kara@acast.com', phone: '+1 (201) 499 7889' },
          ],
        },
      },
    },
    acastplus: {
      hero: {
        title: 'Acast+',
        paragraphs: [
          'Acast+ is your destination to buy premium content directly from the shows and hosts you love.',
          'Get the Acast app and gain access to exclusive content now.',
        ],
      },
      offer: {
        title: 'Get More',
        subtitle:
          'Get more from your favorite podcasters and enjoy a premium experience with up to four perks:',
        premiumcontent: 'Premium Content',
        exclusiveaccess: 'Exclusive Access',
        noads: 'Ad-free Listenings',
        earlyaccess: 'Early Releases',
        backcatalog: 'Access Back Catalog',
      },
      getApp: {
        title: 'Start using Acast+',
        body: ' ',
      },
    },
  },
};

export default {
  get: get,
  getBoolean: getBoolean,
  asJson: stringsByLanguage,
  setLanguage: setLanguage,
  addLanguageObserver: addLanguageObserver,
  removeLanguageObserver: removeLanguageObserver,
};

function get(id) {
  if (id === 'use_fallback_instead_of_translation_key') {
    // this value is supplied from Keystone when a specific string should be used
    return '';
  }

  var parts = id.split('.');
  var strings = stringsByLanguage[currentLanguage];
  var string = '';

  if (parts.length) {
    for (var p = 0; p < parts.length - 1; p++) {
      if (strings[parts[p]]) {
        strings = strings[parts[p]];
      } else {
        break;
      }
    }
    string = strings[parts[p]];
  }

  if (!string) {
    console.warn(
      `StringStore.get: Key ${id} doesn't exist for language ${currentLanguage}`
    );
  }
  return string;
}

function getBoolean(id) {
  const value = this.get(id);
  const type = typeof value;
  if (type === 'string') {
    return value === 'true';
  }

  if (type === 'boolean') {
    value;
  }

  throw new Error('Unsupported format ' + value);
}

function setLanguage(lang) {
  if (stringsByLanguage[lang]) {
    currentLanguage = lang;
  } else {
    console.warn(
      `StringStore.setLanguage: ${
        lang
      } is an unsupported language, defaulting to english`
    );
    currentLanguage = 'en';
  }
  notifyObservers();
}

function addLanguageObserver(observer) {
  if (observers.indexOf(observer) === -1) {
    observers.push(observer);
  }
}

function removeLanguageObserver(observer) {
  let i = observer.indexOf(observer);
  if (i !== -1) {
    observers.splice(i, 1);
  }
}

function notifyObservers() {
  for (var o = 0; o < observers.length; o++) {
    observers[o](currentLanguage);
  }
}



// WEBPACK FOOTER //
// ./client/stores/strings.es6